import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "fontawesome-free-v6/css/all.min.css";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";

import Footer from "./Component/Layouts/Footer/Footer";
import Header from "./Component/Layouts/Header/Header";
import UserHeader from "./Component/Layouts/Header/UserHeader.jsx";
import About from "./Component/Pages/About";
import Changepassword from "./Component/Pages/Changepassword";
import Contact from "./Component/Pages/Contact";
import EmailVerify from "./Component/Pages/EmailVerify";
import Forgotpassword from "./Component/Pages/Forgotpassword";
import Home from "./Component/Pages/Home";
import Login from "./Component/Pages/Login";
import Register from "./Component/Pages/Register";
import Resetpassword from "./Component/Pages/Resetpassword";
import Services from "./Component/Pages/Services";
import Effortlessglobalpayments from "./Component/Pages/Effortlessglobalpayments.jsx";
import Applyforletterofcredit from "./Component/Pages/Applyforletterofcredit.jsx";
import Tuitionpaymentsforcanada from "./Component/Pages/Tuitionpaymentsforcanada.jsx";
import Realestateinvestmentpayments from "./Component/Pages/Realestateinvestmentpayments.jsx";
import Privacypolicy from "./Component/Pages/Privacypolicy.jsx";
import Termsofservice from "./Component/Pages/Termsofservice.jsx";

//User
import Userdashboard from "./Component/Pages/User/Userdashboard";
import Userrequestquote from "./Component/Pages/User/Userrequestquote";
import Userorders from "./Component/Pages/User/Userorders.jsx";
import Receiverdetails from "./Component/Pages/User/Receiverdetails.jsx";
import Userprofile from "./Component/Pages/User/Userprofile.jsx";
import Trackorder from "./Component/Pages/User/Trackorder.jsx"

//Admin
import Admindashboard from "./Component/Pages/Admin/Admindashboard.jsx";
import AdminFooter from "./Component/Layouts/Footer/AdminFooter.jsx";
import AdminHeader from "./Component/Layouts/Header/AdminHeader.jsx";
import AdminControlPanel from "./Component/Pages/Admin/ControlPanel.jsx";
import AdminOrders from "./Component/Pages/Admin/Orders.jsx";
import AdminQuotations from "./Component/Pages/Admin/Quotations.jsx";
import AdminUserProfiles from "./Component/Pages/Admin/UserProfiles.jsx";
import Bankdetails from "./Component/Pages/Admin/Bankdetails.jsx";
import Admintestimonial from "./Component/Pages/Admin/Admintestimonial.jsx";
import Adminprofile from "./Component/Pages/Admin/Adminprofile.jsx";
import PageLoader from "./Component/PageLoader.jsx";
import Kyc from "./Component/Pages/User/kyc.jsx";
//404
import Error404 from "./Component/Pages/404.jsx";

import { useSelector } from "react-redux";
import { login, userStore } from "./redux/reduxStore.js";

const App = () => {
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token") || null;
    if (!token) {
      return setShowPage(true);
    } else {
      try {
        const decode = jwtDecode(token)
        axios({
          method: "GET",
          url: `${process.env.REACT_APP_BASE_URL}/user/${decode?.userId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => {
            userStore.dispatch(
              login({
                user: res.data.user,
                token: token,
              })
            );
            return setShowPage(true);
          })
          .catch((err) => {
            return setShowPage(true);
          });
      } catch (error) {
        return setShowPage(true);
      }
    }
  }, []);

  const isLogin = useSelector((state) => state.isLogin);
  const isAdmin = useSelector((state) => state?.user?.isAdmin || false);
  if (!showPage) {
    return (
      <>
        <PageLoader />
      </>
    );
  } else if (isAdmin) {
    return (
      <>
        <AdminHeader />
        <Routes>
          <Route path="/" element={<Admindashboard />} />
          <Route path="/dashboard" element={<Admindashboard />} />
          <Route path="/users" element={<AdminUserProfiles />} />
          <Route path="/quotations" element={<AdminQuotations />} />
          <Route path="/orders" element={<AdminOrders />} />
          <Route path="/admintestimonial" element={<Admintestimonial />} />
          <Route path="/controlpanel" element={<AdminControlPanel />} />
          <Route path="/bankdetails/:settingId/:currency" element={<Bankdetails />} />
          <Route path="/admintestimonial" element={<Admintestimonial />} />
          <Route path="/adminprofile" element={<Adminprofile />} />
          <Route path="/changepassword" element={<Changepassword />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
        <AdminFooter />
        <ToastContainer />
      </>
    );
  } else if (isLogin) {
    return (
      <>
        <UserHeader />
        <Routes>
          <Route path="/" element={<Userrequestquote />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/" element={<Services />} />
          <Route path="/effortlessglobalpayments" element={<Effortlessglobalpayments />} />
          <Route path="/applyforletterofcredit" element={<Applyforletterofcredit />} />
          <Route path="/tuitionpaymentsforcanada" element={<Tuitionpaymentsforcanada />} />
          <Route path="/realestateinvestmentpayments" element={<Realestateinvestmentpayments />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/termsofservice" element={<Termsofservice />} />
          <Route path="/dashboard" element={<Userdashboard />} />
          <Route path="/userrequestquote" element={<Userrequestquote />} />Receiverdetails
          <Route path="/userorders" element={<Userorders />} />Trackorder
          <Route path="/trackorder" element={<Trackorder />} />
          <Route path="/receiverdetails/:quotationId" element={<Receiverdetails />} />
          <Route path="/userprofile" element={<Userprofile />} />
          <Route path="/changepassword" element={<Changepassword />} />
          <Route path="/kyc" element={<Kyc />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
        <Footer />
        <ToastContainer />
      </>
    );
  } else {
    return (
      <>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/services/" element={<Services />} />
          <Route path="/effortlessglobalpayments" element={<Effortlessglobalpayments />} />
          <Route path="/applyforletterofcredit" element={<Applyforletterofcredit />} />
          <Route path="/tuitionpaymentsforcanada" element={<Tuitionpaymentsforcanada />} />
          <Route path="/realestateinvestmentpayments" element={<Realestateinvestmentpayments />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/termsofservice" element={<Termsofservice />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login/:token" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="/email-verify/:token" element={<EmailVerify />} />
          <Route path="/reset-password/:token" element={<Resetpassword />} />
          <Route path="/loader" element={<PageLoader />} />
          <Route path="*" element={<Error404 />} />
          <Route path="/email-verify/:token" element={<EmailVerify />} />
          <Route path="/reset-password/:token" element={<Resetpassword />} />
          <Route path="/services/:token" element={<Services />} />
        </Routes>
        <Footer />
        <ToastContainer />
      </>
    );
  }
};

export default App;